module.exports = __webpack_public_path__ + "img/quizz-step-10-4.473cb066.jpg";